import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api/client";
import { useEvent } from "../context/EventProvider";

/** Une ligne du classement. Rien de plus qu'un badge ne porte déjà. */
export type Ranked = { rank: number; id: number; name: string; points: number };

/**
 * LE CLASSEMENT.
 *
 * ⚠️ SON APPELANT EST `Podium.tsx`, ET IL N'ARRIVE QUE QUAND LE CLASSEMENT EST À
 * L'ÉCRAN. Le podium a été un temps sans déclencheur : le sélecteur « ce que la salle
 * affiche » qui le commandait a été retiré au tri du 2026-08-12, et cette route est
 * restée écrite et testée sans que rien puisse l'afficher. Le classement est depuis un
 * TYPE D'ACTIVITÉ, que la régie lance comme un sondage.
 *
 * ⚠️ IL SE RELIT, IL N'EST PAS POUSSÉ. Il change à chaque bonne réponse de chaque
 * personne, donc le diffuser reviendrait à un message par vote pour une donnée que
 * personne ne regarde tant que la régie ne l'affiche pas. Il est demandé quand
 * l'écran de salle le montre, et rafraîchi tant qu'il le montre.
 *
 * ⚠️ ET LE CLASSEMENT DE LA V1 CROIT SE RAFRAÎCHIR TOUTES LES CINQ SECONDES : son
 * `Leaderboard/index.jsx` utilise un `setTimeout`, donc il ne se déclenche qu'une
 * fois. Le podium reste figé sur son premier état pendant toute la session.
 */
export function useLeaderboard({
  enabled,
  screenToken,
  top = 10,
  teams = false,
}: {
  enabled: boolean;
  screenToken?: string | null;
  top?: number;
  teams?: boolean;
}) {
  const event = useEvent();

  return useQuery({
    queryKey: [
      "leaderboard",
      event?.domainId,
      event?.eventId,
      top,
      teams,
      screenToken ?? null,
    ],
    queryFn: ({ signal }) => {
      const query = new URLSearchParams({ limit: String(top) });
      if (teams) query.set("teams", "true");
      if (screenToken) query.set("token", screenToken);
      return apiFetch<Ranked[]>(
        `/domains/${event!.domainId}/events/${event!.eventId}/live/leaderboard?${query}`,
        { api: "apix", signal },
      );
    },
    enabled: enabled && !!event,
    refetchInterval: 10_000,
    retry: false,
  });
}
